// export enum ApplicationStatuses {
//   Created = 1, // ro'yxatdan o'tgan
//   Approved = 2, // tasdiqlangan

//   /// ishtirok etgan
//   //Participated = 2,

//   ///  ishtirok etmagan, masalan, ro'yxatdan o'tgan, lekin imtihonga kelmagan
//   Absent = 3,

//   ///  Diskvalifikatsiya qilingan, masalan, qoidalarni buzgan yoki boshqa sabablar bilan
//   Disqualified = 4,

//   ///  keyingi bosqichga o'tgan
//   Qualified = 5,

//   ///  keyingi bosqichga o'tmagan,
//   ///  PS: bu kerak bo'lmasligi mumkin, chunki ishtirok etmagan va diskvalifikatsiya qilinganlar ham keyingi bosqichga o'tmaydi
//   NotQualified = 6,

//   //Ariza tasdiqlanmagan bekor qilingan
//   Rejected = 7,

//   Accepted = 8,
//   Allowed = 9,
//   NotAllowed = 10,
//   SetTestDate = 11,
//   MissedTest1 = 12,
//   MissedTest2 = 13,
//   FailedTest = 14,
//   PassedTest = 15,
//   SetVerbalDate = 16,
//   MissedVerbal1 = 17,
//   MissedVerbal2 = 18,
//   FailedAttestation = 19,
//   PassedAttestation = 20,
// }

// export enum ApplicationStatuses {
//   Created = 1, //
//   GivenInvoys = 2,
//   Payment = 3,
//   InProcess = 4,
//   RejectedModify = 5,
//   Rejected = 6, //
//   Cancelled = 7,
//   Accepted = 8, //
//   Allowed = 9,
//   NotAllowed = 10,
//   SetTestDate = 11,
//   MissedTest = 12,
//   FailedTest = 14,
//   PassedTest = 15,
//   SetVerbalDate = 16,
//   MissedVerbal = 17,
//   FailedAttestation = 19,
//   PassedAttestation = 20,
// }

export enum ApplicationStatus
{
    Created = 1, // ro'yxatdan o'tgan
    Approved = 2, // tasdiqlangan

    /// <summary>
    /// ishtirok etgan
    /// </summary>
    //Participated = 2,

    /// <summary>
    ///  ishtirok etmagan, masalan, ro'yxatdan o'tgan, lekin imtihonga kelmagan
    /// </summary>
    Absent = 3,

    /// <summary>
    ///  Diskvalifikatsiya qilingan, masalan, qoidalarni buzgan yoki boshqa sabablar bilan
    /// </summary>
    Disqualified = 4,

    /// <summary>
    ///  keyingi bosqichga o'tgan
    /// </summary>
    Qualified = 5,


    /// <summary>
    ///  keyingi bosqichga o'tmagan,
    ///  PS: bu kerak bo'lmasligi mumkin, chunki ishtirok etmagan va diskvalifikatsiya qilinganlar ham keyingi bosqichga o'tmaydi   
    /// </summary>
    NotQualified = 6,

    //Ariza tasdiqlanmagan bekor qilingan
    Rejected = 7,
}
